import { formatLine } from './lineDataUtils';

export const isNewLock = (newLock, existingLocks) =>
  !existingLocks.some(
    (existingLock) =>
      existingLock.gameId === newLock.gameId &&
      existingLock.pickType === newLock.pickType
  );

export const formatLockSuccessToastMessage = (lock) => {
  if (lock.pickType === 'bye') {
    return `Your bye week is locked — Week ${lock.weekNumber}`;
  }

  const gameDisplay =
    lock.awayTeam && lock.homeTeam
      ? `${lock.awayTeam} @ ${lock.homeTeam}`
      : '';

  if (lock.pickType === 'over' || lock.pickType === 'under') {
    const prefix = lock.pickType === 'over' ? 'Over' : 'Under';
    return `Locked: ${prefix} ${Math.abs(lock.lockLine)} — ${gameDisplay}`;
  }

  const line = lock.pickType === 'home' ? lock.lockLine : -lock.lockLine;
  const teamLabel = lock.team || lock.pickType;
  return `Locked: ${teamLabel} ${formatLine(line)} — ${gameDisplay}`;
};

export const formatLockFailureMessage = (error) =>
  error?.message || 'Could not lock pick. Please try again.';

/**
 * Build toast payload when the current user has newly confirmed locks.
 * Returns null if no user-owned new locks (e.g. another member locked).
 */
export const buildLockSuccessToast = (userNewLocks, weekNumber) => {
  if (!userNewLocks?.length) return null;

  const message =
    userNewLocks.length === 1
      ? formatLockSuccessToastMessage(userNewLocks[0])
      : `Locked ${userNewLocks.length} picks — Week ${weekNumber}`;

  return { message, severity: 'success' };
};

export const getUserNewLocks = (confirmedLocks, existingLocks, userId) => {
  if (!confirmedLocks?.length || userId == null) return [];

  return confirmedLocks.filter(
    (lock) => lock.userId === userId && isNewLock(lock, existingLocks)
  );
};
